export enum CountryImg {
  Afghanistan = 'country-Afghanistan.svg',
  Africa = 'country-Africa.svg',
  Aland_Islands = 'country-Aland_Islands.svg',
  Albania = 'country-Albania.svg',
  Algeria = 'country-Algeria.svg',
  Andorra = 'country-Andorra.svg',
  Angola = 'country-Angola.svg',
  Anguilla = 'country-Anguilla.svg',
  Antigua_and_Barbuda = 'country-Antigua_and_Barbuda.svg',
  Argentina = 'country-Argentina.svg',
  Armenia = 'country-Armenia.svg',
  Aruba = 'country-Aruba.svg',
  Asia = 'country-Asia.svg',
  Australia = 'country-Australia.svg',
  Austria = 'country-Austria.svg',
  Azerbaijan = 'country-Azerbaijan.svg',
  Bahamas = 'country-Bahamas.svg',
  Bahrain = 'country-Bahrain.svg',
  Bangladesh = 'country-Bangladesh.svg',
  Barbados = 'country-Barbados.svg',
  Belarus = 'country-Belarus.svg',
  Belgium = 'country-Belgium.svg',
  Belize = 'country-Belize.svg',
  Benin_Benin = 'country-Benin_Benin.svg',
  Bermuda = 'country-Bermuda.svg',
  Bhutan = 'country-Bhutan.svg',
  Bolivia = 'country-Bolivia.svg',
  Bosnia_and_Herzegovina = 'country-Bosnia_and_Herzegovina.svg',
  Botswana = 'country-Botswana.svg',
  Brazil = 'country-Brazil.svg',
  British_Virgin_Islands = 'country-British_Virgin_Islands.svg',
  Brunei = 'country-Brunei.svg',
  Bulgaria = 'country-Bulgaria.svg',
  BurkinaFaso = 'country-Burkina-faso.svg',
  Burma = 'country-Burma.svg',
  Burundi = 'country-Burundi.svg',
  Cabo_Verde = 'country-Cabo_Verde.svg',
  Cambodia = 'country-Cambodia.svg',
  Cameroon = 'country-Cameroon.svg',
  Canada = 'country-Canada.svg',
  Cayman_Islands = 'country-Cayman_Islands.svg',
  Central_African_Republic = 'country-Central_African_Republic.svg',
  Chad = 'country-Chad.svg',
  Chile = 'country-Chile.svg',
  China = 'country-China.svg',
  Colombia = 'country-Colombia.svg',
  Comoros = 'country-Comoros.svg',
  Congo = 'country-Congo.svg',
  Costa_Rica = 'country-Costa_Rica.svg',
  Cote_d_Ivoire = 'country-Cote_d_Ivoire.svg',
  Croatia_Hrvatska = 'country-Croatia_Hrvatska.svg',
  Cuba = 'country-Cuba.svg',
  Cyprus = 'country-Cyprus.svg',
  Czech_Republic = 'country-Czech_Republic.svg',
  Democratic_Republic_of_Congo = 'country-Democratic_Republic_of_Congo.svg',
  Denmark = 'country-Denmark.svg',
  Djibouti = 'country-Djibouti.svg',
  Dominica_Rep = 'country-Dominica_Rep.svg',
  Dominican_Republic_Republica_Dominicana = 'country-Dominican_Republic_Republica_Dominicana.svg',
  Ecuador = 'country-Ecuador.svg',
  Egypt = 'country-Egypt.svg',
  El_Salvador = 'country-El_Salvador.svg',
  Equatorial_Guinea_Guinea_Ecuatorial = 'country-Equatorial_Guinea_Guinea_Ecuatorial.svg',
  Eritrea = 'country-Eritrea.svg',
  Estonia = 'country-Estonia.svg',
  Eswatini = 'country-Eswatini.svg',
  Ethiopia = 'country-Ethiopia.svg',
  Europe = 'country-Europe.svg',
  European_Union = 'country-European_Union.svg',
  Falkland_Islands_Islas_Malvinas = 'country-Falkland_Islands_Islas_Malvinas.svg',
  Fiji = 'country-Fiji.svg',
  Finland = 'country-Finland.svg',
  France = 'country-France.svg',
  French_Polynesia = 'country-French_Polynesia.svg',
  Gabon = 'country-Gabon.svg',
  Gambia = 'country-Gambia.svg',
  Georgia = 'country-Georgia.svg',
  Germany = 'country-Germany.svg',
  Ghana = 'country-Ghana.svg',
  Gibraltar = 'country-Gibraltar.svg',
  Greece = 'country-Greece.svg',
  Grenada = 'country-Grenada.svg',
  Guatemala = 'country-Guatemala.svg',
  Guernsey = 'country-Guernsey.svg',
  GuineaBissau_Guine_Bissau = 'country-Guinea-Bissau_Guine_Bissau.svg',
  Guinea = 'country-Guinea.svg',
  Guyana = 'country-Guyana.svg',
  Haiti = 'country-Haiti.svg',
  Honduras = 'country-Honduras.svg',
  Hong_Kong = 'country-Hong_Kong.svg',
  Hungary = 'country-Hungary.svg',
  Iceland = 'country-Iceland.svg',
  India = 'country-India.svg',
  Indonesia = 'country-Indonesia.svg',
  Iran = 'country-Iran.svg',
  Iraq = 'country-Iraq.svg',
  Ireland = 'country-Ireland.svg',
  Isle_of_Man = 'country-Isle_of_Man.svg',
  Israel = 'country-Israel.svg',
  Italy = 'country-Italy.svg',
  Jamaica = 'country-Jamaica.svg',
  Japan = 'country-Japan.svg',
  Jersey = 'country-Jersey.svg',
  Jordan = 'country-Jordan.svg',
  Kazakhstan = 'country-Kazakhstan.svg',
  Kenya = 'country-Kenya.svg',
  Kuwait = 'country-Kuwait.svg',
  Kyrgyzstan = 'country-Kyrgyzstan.svg',
  Laos = 'country-Laos.svg',
  Latvia = 'country-Latvia.svg',
  Lebanon = 'country-Lebanon.svg',
  Lesotho = 'country-Lesotho.svg',
  Liberia = 'country-Liberia.svg',
  Libya = 'country-Libya.svg',
  Liechtenstein = 'country-Liechtenstein.svg',
  Lithuania = 'country-Lithuania.svg',
  Luxembourg = 'country-Luxembourg.svg',
  Macau = 'country-Macau.svg',
  Macedonia_FYROM = 'country-Macedonia_FYROM.svg',
  Madagascar = 'country-Madagascar.svg',
  Malawi = 'country-Malawi.svg',
  Malaysia = 'country-Malaysia.svg',
  Maldives = 'country-Maldives.svg',
  Mali = 'country-Mali.svg',
  Malta = 'country-Malta.svg',
  Mauritania = 'country-Mauritania.svg',
  Mauritius = 'country-Mauritius.svg',
  Mexico = 'country-Mexico.svg',
  Micronesia = 'country-Micronesia.svg',
  Moldova_RepublicOf = 'country-Moldova_RepublicOf.svg',
  Monaco = 'country-Monaco.svg',
  Mongolia = 'country-Mongolia.svg',
  Montenegro_Crna_Gora = 'country-Montenegro_Crna_Gora.svg',
  Montserrat = 'country-Montserrat.svg',
  Morocco = 'country-Morocco.svg',
  Mozambique = 'country-Mozambique.svg',
  Namibia = 'country-Namibia.svg',
  Nepal = 'country-Nepal.svg',
  Netheriands_Antilles = 'country-Netheriands_Antilles.svg',
  Netherlands = 'country-Netherlands.svg',
  New_Zealand = 'country-New_Zealand.svg',
  Nicaragua = 'country-Nicaragua.svg',
  Niger = 'country-Niger.svg',
  Nigeria = 'country-Nigeria.svg',
  North_America = 'country-North_America.svg',
  North_Korea = 'country-North_Korea.svg',
  Norway = 'country-Norway.svg',
  Oceania = 'country-Oceania.svg',
  Oman = 'country-Oman.svg',
  Pakistan = 'country-Pakistan.svg',
  Palau = 'country-Palau.svg',
  Panama = 'country-Panama.svg',
  Papua_New_Guinea = 'country-Papua_New_Guinea.svg',
  Paraguay = 'country-Paraguay.svg',
  Peru = 'country-Peru.svg',
  Philippines = 'country-Philippines.svg',
  Poland = 'country-Poland.svg',
  Portugal = 'country-Portugal.svg',
  Puerto_Rico = 'country-Puerto_Rico.svg',
  Qatar = 'country-Qatar.svg',
  Romania = 'country-Romania.svg',
  Russia = 'country-Russia.svg',
  Rwanda = 'country-Rwanda.svg',
  Saint_Helena = 'country-Saint_Helena.svg',
  Saint_Kitts_and_Nevis = 'country-Saint_Kitts_and_Nevis.svg',
  Saint_Lucia = 'country-Saint_Lucia.svg',
  Saint_Vincent_and_the_Grenadines = 'country-Saint_Vincent_and_the_Grenadines.svg',
  Samoa = 'country-Samoa.svg',
  San_Marino = 'country-San_Marino.svg',
  Sao_Tome_and_Principe = 'country-Sao_Tome_and_Principe.svg',
  Saudi_Arabia = 'country-Saudi_Arabia.svg',
  Senegal = 'country-Senegal.svg',
  Serbia = 'country-Serbia.svg',
  Seychelles = 'country-Seychelles.svg',
  Sierra_Leone = 'country-Sierra_Leone.svg',
  Singapore = 'country-Singapore.svg',
  Slovakia = 'country-Slovakia.svg',
  Slovenia = 'country-Slovenia.svg',
  Solomon_Islands = 'country-Solomon_Islands.svg',
  Somali = 'country-Somali.svg',
  South_Africa = 'country-South_Africa.svg',
  South_America = 'country-South_America.svg',
  South_Korea = 'country-South_Korea.svg',
  Spain = 'country-Spain.svg',
  Sri_Lanka = 'country-Sri_Lanka.svg',
  Sudan = 'country-Sudan.svg',
  Suriname = 'country-Suriname.svg',
  Sweden = 'country-Sweden.svg',
  Switzerland = 'country-Switzerland.svg',
  Syria = 'country-Syria.svg',
  Taiwan = 'country-Taiwan.svg',
  Tajikistan = 'country-Tajikistan.svg',
  Tanzania = 'country-Tanzania.svg',
  Thailand = 'country-Thailand.svg',
  Timor_Leste = 'country-Timor_Leste.svg',
  Togo = 'country-Togo.svg',
  Tonga = 'country-Tonga.svg',
  Trinidad_and_Tobago = 'country-Trinidad_and_Tobago.svg',
  Tunisia = 'country-Tunisia.svg',
  Turkey = 'country-Turkey.svg',
  Turkmenistan = 'country-Turkmenistan.svg',
  Turks_and_Caicos_Islands = 'country-Turks_and_Caicos_Islands.svg',
  Uganda = 'country-Uganda.svg',
  Ukraine = 'country-Ukraine.svg',
  United_Arab_Emirates = 'country-United_Arab_Emirates.svg',
  United_Kingdom = 'country-United_Kingdom.svg',
  United_States_of_America = 'country-United_States_of_America.svg',
  Uruguay = 'country-Uruguay.svg',
  Uzbekistan = 'country-Uzbekistan.svg',
  Vanuata = 'country-Vanuata.svg',
  Venezuela = 'country-Venezuela.svg',
  Vietnam = 'country-Vietnam.svg',
  Worldwide = 'country-Worldwide.svg',
  Yemen = 'country-Yemen.svg',
  Zambia = 'country-Zambia.svg',
  Zimbabwe = 'country-Zimbabwe.svg',
}
